module.exports = __webpack_public_path__ + "static/media/6.7_preview.d8e4ad05.png";